import styled from 'styled-components';
import {LargeSectionHeader} from '../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const GuestRnRWrapper = styled.section(
  props => `

  width: 100%;
  margin: 0 auto;
  max-width:120rem;
  background-color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  margin-top: ${props.theme.spacing.large};
`,
);

export const GuestRnRHeaderStyled = styled(LargeSectionHeader)(
  props => `

  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;

`,
);

export const GuestRnRListBlock = styled.div(
  props => `
    padding: ${props.theme.spacing.xxlarge};
    border-radius: ${props.theme.misc.borderRadius.large};
    border-top-left-radius:0;
    border-top-right-radius:0;
  `,
);

export const ReviewListBlock = styled.ul(
  props => `
      display:flex;
      flex-direction: column;
      li{
          border:1px solid #eef4fd;
          margin-bottom:${props.theme.spacing.base};
          padding:24px 26px 21px;
          border-radius: ${props.theme.misc.borderRadius.xlarge};
          &:last-child {
            margin-bottom: 0;
          }
      }
    `,
);

export const ReviewText = styled.p(
  props => `
    font-size: ${props.theme.font.custom(16)};
    margin-top:${props.theme.spacing.large};
    `,
);

export const RatingSpan = styled.span(
  props => `
      background-color:#18a160;
      padding:7px 8px;
      color:white;
      font-size:18px;
      font-weight:600;
      border-radius: ${props.theme.misc.borderRadius.base};
      `,
);

export const HeadingPara = styled.p(
  props => `
     font-size: ${props.theme.font.custom(16)};
     font-weight: 600;
     margin-bottom:${props.theme.spacing.custom(4)};
    `,
);

export const UsernameSpan = styled.span(
  props => `
    font-size: ${props.theme.font.custom(14)};
    margin-right: ${props.theme.spacing.small};
    font-weight: 600;
    `,
);

export const StayDuration = styled.span(
  props => `
    font-size: ${props.theme.font.custom(14)};
    color:#4f525a;
    `,
);

export const TextBtnRead = styled.span(
  props => `
  display: flex;
  flex-direction: row;
  color: #2274e0;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
`,
);

export const ReviewListItem = styled.li(
  props => `
    display: ${props.displayReview ? 'block' : 'none'};    
`,
);
